import React, { createContext, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import App from 'App';

import { LayoutProvider } from '@contexts/LayoutContext';
import { ListContextProvider } from '@contexts/ListContext';
import NavigationContext from '@contexts/NavigationContext';
import NavigationReducer from '@contexts/NavigationReducer';
import { StateProvider } from '@contexts/StateProvider';
import { UserContextProvider } from '@contexts/UserContext';
import { UserGuiConfigContextProvider } from '@contexts/UserGuiConfigContext';

export const UpdateCalendarContext = createContext(null);

const GlobalContext = () => {
    const [updateCalendar, setUpdateCalendar] = useState(false);

    return (
        <BrowserRouter>
            <StateProvider initialState={NavigationContext} reducer={NavigationReducer}>
                <ListContextProvider>
                    <UserContextProvider>
                        <LayoutProvider>
                            <UserGuiConfigContextProvider>
                                <UpdateCalendarContext.Provider value={{ updateCalendar, setUpdateCalendar }}>
                                    <App />
                                </UpdateCalendarContext.Provider>
                            </UserGuiConfigContextProvider>
                        </LayoutProvider>
                    </UserContextProvider>
                </ListContextProvider>
            </StateProvider>
        </BrowserRouter>
    );
};
const GlobalContextProvider = GlobalContext; //process.env.NODE_ENV === "development" ? hot(GlobalContext) : GlobalContext
export default GlobalContextProvider;
